var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offers-page--main-wrapper product-desc"},[_c('top-header'),_c('div',{staticClass:"offers-page--outer-wrapper mt-25"}),_c('top-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }